import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';

const Gender = (ssn) =>{
    
    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'donorbyssn',
        payload:  {id: ssn}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;

    return ((data)? data.gender : null)
}

export default Gender